import React from 'react'

const PathogenTesting = () => {
  return (
    <div id='website-responsive'>
    <div className='left-padding6rem1 right-padding6rem1 py-md-5 pt-4'>
        <div className=''>
            <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                Respiratory Pathogen Panel Testing In Chicago
            </div>
            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
        </div>

        <div className='pb-3'>
            <div className='fs-ss-20-2 text-montserrat fw-600 text-ss-black lh-1-2 pb-2 pt-1' style={{ fontStyle:'italic'}}>
                What Exactly Is an RPP Panel Test?
            </div>
        </div>

        <div className='pb-3'>
            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
            The respiratory system can be infected with various bacteria and viruses. While the signs and symptoms are frequently the same, the treatment can vary greatly. Therefore, making the appropriate diagnosis is crucial. Most of the time, other tests for respiratory infections using viruses and bacteria only look for one pathogen and there may be a need for several samples.
            </div>
        </div>

        <div className=''>
            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
            At United Lab Care, we offer professional<strong> Respiratory Pathogen Panel (RPP)</strong> testing services in Chicago, that require only one sample. While it may take some days to receive the results of other respiratory tests, with United Lab Care the test results are available in the least amount of time. So, that you can begin the appropriate treatment sooner.
            </div>
        </div>
    </div>
</div>
  )
}

export default PathogenTesting